var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSchool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.8981V22.5H17V12.8981C17 11.8299 17 11.2958 16.7554 10.8478C16.5108 10.3998 16.0616 10.111 15.163 9.53338L13.0815 8.19526C12.5563 7.85763 12.2937 7.68881 12 7.68881C11.7063 7.68881 11.4437 7.85763 10.9185 8.19526L8.83697 9.53338C7.93842 10.111 7.48915 10.3998 7.24458 10.8478C7 11.2958 7 11.8299 7 12.8981Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.47035V5.48221H16C16 4.80914 15.8285 4.06105 15.2203 3.68653C14.5 3.24303 12.6061 2.14939 12.1464 2.61173C12 2.75905 12 2.99615 12 3.47035Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.6623V22.5H7V13.5C4.25916 14.1852 3 14.3707 3 16.6623Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.6623V22.5H17V13.5C19.7408 14.1852 21 14.3707 21 16.6623Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5V5.48221M12 5.48221V3.47035C12 2.99615 12 2.75905 12.1464 2.61173C12.6061 2.14939 14.5 3.24303 15.2203 3.68653C15.8285 4.06105 16 4.80914 16 5.48221H12Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22.5V12.8981C7 11.8299 7 11.2958 7.24458 10.8478C7.48915 10.3998 7.93842 10.111 8.83697 9.53338L10.9185 8.19526C11.4437 7.85763 11.7063 7.68881 12 7.68881C12.2937 7.68881 12.5563 7.85763 13.0815 8.19526L15.163 9.53338C16.0616 10.111 16.5108 10.3998 16.7554 10.8478C17 11.2958 17 11.8299 17 12.8981V22.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5H12.009",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.5V16.6623C21 14.3707 19.7408 14.1852 17 13.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3 22.5V16.6623C3 14.3707 4.25916 14.1852 7 13.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22.5H22",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5V18.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchool);
export default __webpack_public_path__ + "static/media/icon-school.4389f950e19f1ee107f4590babbb4f93.svg";
export { ForwardRef as ReactComponent };